// Alt Shop by Categories Carousel - Custom 3-card carousel with 1-card scrolling
document.addEventListener('DOMContentLoaded', function() {
  function initAltShopByCategoriesCarousel() {
    const altShopByCategoriesSection = document.querySelector('.alt-shop-by-categories');
    if (!altShopByCategoriesSection) return;

    const carousel = altShopByCategoriesSection.querySelector('.alt-shop-by-categories__grid');
    const prevButton = altShopByCategoriesSection.querySelector('button[name="previous"]');
    const nextButton = altShopByCategoriesSection.querySelector('button[name="next"]');

    if (!carousel || !prevButton || !nextButton) return;

    // Calculate card width including gap for precise scrolling
    function getCardScrollDistance() {
      const cards = carousel.querySelectorAll('.grid__item');
      if (cards.length === 0) return 0;

      const cardWidth = cards[0].offsetWidth;
      // Use Dawn's CSS variable for grid spacing
      const computedStyle = getComputedStyle(carousel);
      const gap = parseInt(computedStyle.getPropertyValue('--grid-desktop-horizontal-spacing')) ||
                  parseInt(computedStyle.gap) ||
                  (window.innerWidth >= 990 ? 24 : (window.innerWidth >= 750 ? 12 : 8));
      return cardWidth + gap;
    }

    // Check if we're on desktop (3-card layout) or mobile/tablet
    function isDesktopLayout() {
      return window.innerWidth >= 990;
    }

    // Custom scroll behavior for 1-card movement
    function scrollCarousel(direction) {
      const scrollDistance = getCardScrollDistance();
      const currentScroll = carousel.scrollLeft;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;

      let newScrollPosition;
      if (direction === 'next') {
        newScrollPosition = Math.min(maxScroll, currentScroll + scrollDistance);
      } else {
        newScrollPosition = Math.max(0, currentScroll - scrollDistance);
      }

      carousel.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      });
    }

    // Check if navigation should be visible (only if there's overflow)
    function shouldShowNavigation() {
      return carousel.scrollWidth > carousel.clientWidth;
    }

    // Update button states based on scroll position
    function updateButtonStates() {
      const currentScroll = carousel.scrollLeft;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;
      const navigationContainer = altShopByCategoriesSection.querySelector('.alt-shop-by-categories__navigation');

      // Hide navigation if no overflow
      if (!shouldShowNavigation()) {
        if (navigationContainer) {
          navigationContainer.style.display = 'none';
        }
        return;
      } else {
        if (navigationContainer) {
          navigationContainer.style.display = 'flex';
        }
      }

      // Update previous button
      if (currentScroll <= 0) {
        prevButton.setAttribute('disabled', 'disabled');
        prevButton.style.opacity = '0.5';
      } else {
        prevButton.removeAttribute('disabled');
        prevButton.style.opacity = '1';
      }

      // Update next button
      if (currentScroll >= maxScroll - 1) { // -1 for rounding tolerance
        nextButton.setAttribute('disabled', 'disabled');
        nextButton.style.opacity = '0.5';
      } else {
        nextButton.removeAttribute('disabled');
        nextButton.style.opacity = '1';
      }
    }

    // Override default button click handlers for 1-card scrolling
    prevButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollCarousel('prev');
    });

    nextButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollCarousel('next');
    });

    // Listen for scroll events to update button states
    carousel.addEventListener('scroll', updateButtonStates);

    // Initial button state update
    setTimeout(updateButtonStates, 100);

    // Update on window resize
    window.addEventListener('resize', function() {
      setTimeout(updateButtonStates, 100);
    });
  }

  // Initialize after a short delay to ensure DOM is ready
  setTimeout(initAltShopByCategoriesCarousel, 100);
});
